import _each from "lodash/each";
import Vimeo from "@vimeo/player";
import Common from "~/js/common/common";
import { gsap, Cubic } from "gsap";
import { attachTracking } from "~/js/common/vimeo-tracking";
export default class VimeoSection {
  constructor(useSizeAdjust = true) {
    this.useSizeAdjust = useSizeAdjust;
    this.VIMEO_ID = "data-id"; //"data-vimeo-id";
    this.VIMEO_ID_FALLBACK = "data-vimeo-id";
    this.vimeos = [];
    this.currentVimeo = 0;
    this.setup();
  }
  setup() {
    this.createNextVimeo();
  }

  createNextVimeo() {
    const vimeos = document.querySelectorAll(".js-vimeo-section");

    if (vimeos[this.currentVimeo]) {
      let vimeoElm = vimeos[this.currentVimeo];
      this.currentVimeo++;
      this.createVimeoPlayer(vimeoElm);
    }
    /*_each(vimeos, (elm) => {
      this.createVimeoPlayer(elm);
    });*/
  }

  createVimeoPlayer(elm) {
    let vimeoId = elm.getAttribute(this.VIMEO_ID);
    if (!vimeoId) {
      vimeoId = elm.getAttribute(this.VIMEO_ID_FALLBACK);
    }
    if (vimeoId) {
      let background = elm.getAttribute("data-vimeo-background") || false;
      if (background === "0" || background === "false") {
        background = false;
      }
      gsap.set(elm, {
        opacity: 0
      });
      const options = {
        id: vimeoId,
        background: background,
        controls: true,
        muted: background,
        loop: background,
        seekable: true,
        quality: "1080p"
      };
      let vimeoPlayer = new Vimeo(elm, options);
      const startTime = elm.getAttribute("data-vimeo-start") || 0;
      const endTime = elm.getAttribute("data-vimeo-end") || vimeoPlayer.getDuration();

      if (background) {
        vimeoPlayer.setVolume(0);
        vimeoPlayer.setMuted(true);
      }

      vimeoPlayer.setLoop(false);
      vimeoPlayer.ready().then(() => {
        vimeoPlayer.setCurrentTime(startTime);
        let _w = 0;
        let _h = 0;
        vimeoPlayer.getVideoWidth().then((w) => {
          _w = w;
          if (_h !== 0) {
            this.adjustVideoSize(elm, _w, _h);
          }
        });
        vimeoPlayer.getVideoHeight().then((h) => {
          _h = h;
          if (_w !== 0) {
            this.adjustVideoSize(elm, _w, _h);
          }
        });
        gsap.to(elm, {
          opacity: 1,
          delay: 0.1,
          duration: 0.4,
          ease: Cubic.easeInOut
        });

        // 戻り値のPromiseは意図的に非同期で処理（背景動画の自動再生開始をブロックしない）
        attachTracking(vimeoPlayer, { isAutoplay: !!background });

        if (!background) {
          vimeoPlayer.pause();
        }
        this.createNextVimeo();
      });

      vimeoPlayer.on("timeupdate", (event) => {
        if (event.seconds < startTime) {
          vimeoPlayer.setCurrentTime(startTime);
        } else if (event.seconds >= endTime) {
          vimeoPlayer.setCurrentTime(startTime);
        }
      });

      this.vimeos.push({
        id: vimeoId,
        player: vimeoPlayer
      });
    }
  }

  getVimeoPlayer(section) {
    let vimeoId = section.getAttribute(this.VIMEO_ID);
    if (!vimeoId) {
      vimeoId = section.getAttribute(this.VIMEO_ID_FALLBACK);
    }
    let result;
    _each(this.vimeos, (vimeoObject) => {
      if (vimeoObject.id === vimeoId) {
        result = vimeoObject.player;
      }
    });
    return result;
  }

  adjustVideoSize(elm, w, h) {
    if (!this.useSizeAdjust) {
      return;
    }
    if (w < h) {
      let persent = (w / h) * (Common.isSPSize() ? 1.8 : 1.3) * 100;
      let child = elm.firstChild;
      child.style = "padding: " + persent + "% 0 0 0; position: relative;";
    }
  }
}
